var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Heading',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"subtitle-icon":"o_place","tabs":_vm.tabs,"hide-nav":false},on:{"back":function($event){return _vm.$router.push('/services')}}})}
var staticRenderFns = []

export { render, staticRenderFns }